import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import { config } from '../../function/config'
import AdminHeader from './AdminHeader'

export default function AddStaff() {
    const {id} = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [loading, setLoading] = useState(false)
    const [uploading, setUploading] = useState(false)
    const [departments, setDepartments] = useState([])
    const [existingAdmins, setExistingAdmins] = useState([])
    const [existingBranches, setExistingBranches] = useState([])
    const [existingStaffs, setExistingStaffs] = useState([])

    const [selectedFile, setSelectedFile] = useState(null)
    const [openUploadModal, setOpenUploadModal] = useState(false)

    const [formData, setFormData] = useState({
        first_name:'',
        last_name:'',
        age:'',
        dob:'',
        aadhaar_no:'',
        address:'',
        gender:'',
        email:'',
        phone:'',
        role:'',
        department:'',
    })

    const [errors, setErrors] = useState({
        first_name:'',
        last_name:'',
        age:'',
        dob:'',
        aadhaar_no:'',
        address:'',
        gender:'',
        email:'',
        phone:'',
        role:'',
        department:'',
    })

    useEffect(() => {
    const fetchExistingData = async () => {
        try {
        const headers = {
            Authorization: `Token ${token}`
        }

        const [
            adminsResponse,
            branchesResponse,
            staffsResponse
        ] = await Promise.all([
            axios.get(
            `${config.baseurl}get_all_admins/`,
            { headers }
            ),
            axios.get(
            `${config.baseurl}get_all_branches/`,
            { headers }
            ),
            axios.get(
            `${config.baseurl}get_all_staffs/`,
            { headers }
            )
        ])

        const admins = Array.isArray(adminsResponse.data)
            ? adminsResponse.data
            : adminsResponse.data?.data || []

        const branches = Array.isArray(branchesResponse.data)
            ? branchesResponse.data
            : branchesResponse.data?.data || []

        const staffs = Array.isArray(staffsResponse.data)
            ? staffsResponse.data
            : staffsResponse.data?.data || []

        console.log('Admins:', admins)
        console.log('Branches:', branches)
        console.log('Staffs:', staffs)

        setExistingAdmins(admins)
        setExistingBranches(branches)
        setExistingStaffs(staffs)

        } catch (error) {
        console.error(
            'Failed to fetch existing admins/branches/staff:',
            error.response?.data || error
        )
        }
    }

    if (token) {
        fetchExistingData()
    }
    }, [token])

    const fetchDepartments = async() => {
        try{
        const res = await axios.get(`${config.baseurl}get_all_departments/`,{
            headers:{
            'Content-Type':'application/json',
            'Authorization':`Token ${token}`
            }
        })
        console.log('All Departments:', res.data)

        if(res.status === 200){
            setDepartments(res.data.data)
        }else{
            toast.error('Fails to fetch  department data')
        }
        }catch(error){
        console.error('Error:', error.response?.data || error)

        const message =
            error.response?.data?.message ||
            error.response?.data?.error ||
            'Failed to fetch department'

        toast.error(message)
        }
    }

    useEffect(() => {
        fetchDepartments()
    },[token])
    
    const validateAadhaar = (value) => {
        if (!value) return ''

        if (!/^\d+$/.test(value)) {
            return 'Aadhaar should contain only digits'
        }

        if (value.length < 12) {
            return 'Aadhaar should contain exactly 12 digits'
        }

        if (value.length === 12) {

            const exists = existingStaffs.some(
                (staff) =>
                    String(staff.aadhaar_no || '')
                        .replace(/\s/g, '')
                        .trim() === value
            )

            if (exists) {
                return 'Aadhaar number already exists'
            }
        }

        return ''
    }

    const validatePhone = (value) => {
        if (!value) return ''

        if (!/^\d+$/.test(value)) {
            return 'Phone number must contain only digits'
        }

        if (!/^[6-9]/.test(value)) {
            return 'Phone number must start with 6, 7, 8 or 9'
        }

        if (value.length < 10) {
            return 'Phone number must contain exactly 10 digits'
        }

        if (value.length === 10) {

            const exists = existingStaffs.some(
                (staff) =>
                    String(staff.phone || '')
                        .replace(/\s/g, '')
                        .trim() === value
            )

            if (exists) {
                return 'Phone number already exists'
            }
        }

        return ''
    }

    const validateEmail = (value) => {
        if (!value) return ''

        if (!value.includes('@')) {
            return 'Missing @ symbol'
        }

        const parts = value.split('@')

        if (parts.length !== 2) {
            return 'Email can contain only one @ symbol'
        }

        const username = parts[0]
        const domain = parts[1]

        if (!username) {
            return 'Username is missing before @'
        }

        if (!domain) {
            return 'Domain name is missing'
        }

        if (!domain.includes('.')) {
            return 'Missing dot(.) after domain name'
        }

        const allowedDomains = [
            'gmail.com',
            'yahoo.com',
            'hotmail.com',
            'outlook.com'
        ]

        if (!allowedDomains.includes(domain.toLowerCase())) {
            return 'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
        }

        // Check existing email
        const exists = existingStaffs.some(
            (staff) =>
                String(staff.email || '')
                    .trim()
                    .toLowerCase() === value.toLowerCase()
        )

        if (exists) {
            return 'Email already exists'
        }

        return ''
    }

    const handleChange = (e) => {

        const { name, value } = e.target

        let newValue = value
        let error = ''

        // ============================================================
        // DATE OF BIRTH + AUTOMATIC AGE CALCULATION
        // ============================================================

        if (name === 'dob') {

            let calculatedAge = ''

            if (value) {

                const birthDate = new Date(value)
                const today = new Date()

                calculatedAge =
                    today.getFullYear() -
                    birthDate.getFullYear()

                const monthDifference =
                    today.getMonth() - birthDate.getMonth()

                if (
                    monthDifference < 0 ||
                    (
                        monthDifference === 0 &&
                        today.getDate() < birthDate.getDate()
                    )
                ) {
                    calculatedAge--
                }

                // Prevent invalid/future DOB
                if (calculatedAge < 0) {
                    calculatedAge = ''
                }
            }

            setFormData((prev) => ({
                ...prev,
                dob: value,
                age: calculatedAge
            }))

            setErrors((prev) => ({
                ...prev,
                dob: '',
                age: calculatedAge === '' && value
                    ? 'Invalid Date of Birth'
                    : ''
            }))

            return
        }

        // ============================================================
        // FORMAT PHONE
        // ============================================================

        if (name === 'phone') {
            newValue = value
                .replace(/\D/g, '')
                .slice(0, 10)
        }

        // ============================================================
        // FORMAT AADHAAR
        // ============================================================

        if (name === 'aadhaar_no') {
            newValue = value
                .replace(/\D/g, '')
                .slice(0, 12)
        }

        // ============================================================
        // FORMAT EMAIL
        // ============================================================

        if (name === 'email') {
            newValue = value.replace(/\s/g, '')
        }

        // ============================================================
        // UPDATE FORM DATA
        // ============================================================

        setFormData((prev) => ({
            ...prev,
            [name]: newValue
        }))

        // ============================================================
        // AADHAAR VALIDATION
        // ============================================================

        if (name === 'aadhaar_no') {

            if (newValue) {

                if (newValue.length < 12) {

                    error =
                        'Aadhaar should contain exactly 12 digits'

                } else if (newValue.length === 12) {

                    const aadhaarExists =
                        existingStaffs.some(
                            (staff) =>
                                String(staff.aadhaar_no || '')
                                    .replace(/\D/g, '')
                                    .trim() === newValue
                        )

                    if (aadhaarExists) {
                        error =
                            'Aadhaar number already exists'
                    }
                }
            }
        }

        // ============================================================
        // PHONE VALIDATION
        // ============================================================

        if (name === 'phone') {

            if (newValue) {

                if (!/^\d+$/.test(newValue)) {

                    error =
                        'Phone number must contain only digits'

                } else if (!/^[6-9]/.test(newValue)) {

                    error =
                        'Phone number must start with 6, 7, 8 or 9'

                } else if (newValue.length < 10) {

                    error =
                        'Phone number must contain exactly 10 digits'

                } else {

                    const branchPhoneExists =
                        existingBranches.some(
                            (branch) =>
                                String(branch.phone || '').trim() ===
                                newValue
                        )

                    const adminPhoneExists =
                        existingAdmins.some(
                            (admin) =>
                                String(admin.phone || '').trim() ===
                                newValue
                        )

                    const staffPhoneExists =
                        existingStaffs.some(
                            (staff) =>
                                String(staff.phone || '').trim() ===
                                newValue
                        )

                    if (branchPhoneExists) {

                        error =
                            'This phone number already exists in a Branch'

                    } else if (adminPhoneExists) {

                        error =
                            'This phone number already exists for an Admin'

                    } else if (staffPhoneExists) {

                        error =
                            'This phone number already exists for a Staff'
                    }
                }
            }
        }

        // ============================================================
        // EMAIL VALIDATION
        // ============================================================

        if (name === 'email') {

            if (newValue) {

                if (!newValue.includes('@')) {

                    error = 'Missing @ symbol'

                } else {

                    const parts = newValue.split('@')

                    if (parts.length !== 2) {

                        error =
                            'Email can contain only one @ symbol'

                    } else {

                        const username = parts[0]
                        const domain = parts[1]

                        if (!username) {

                            error =
                                'Username is missing before "@"'

                        } else if (!domain) {

                            error =
                                'Domain name is missing'

                        } else if (!domain.includes('.')) {

                            error =
                                'Missing "dot(.)" after domain name'

                        } else {

                            const allowedDomains = [
                                'gmail.com',
                                'yahoo.com',
                                'hotmail.com',
                                'outlook.com'
                            ]

                            if (
                                !allowedDomains.includes(
                                    domain.toLowerCase()
                                )
                            ) {

                                error =
                                    'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'

                            } else {

                                const email =
                                    newValue.trim().toLowerCase()

                                const branchEmailExists =
                                    existingBranches.some(
                                        (branch) =>
                                            String(branch.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                const adminEmailExists =
                                    existingAdmins.some(
                                        (admin) =>
                                            String(admin.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                const staffEmailExists =
                                    existingStaffs.some(
                                        (staff) =>
                                            String(staff.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                if (branchEmailExists) {

                                    error =
                                        'This email already exists in a Branch'

                                } else if (adminEmailExists) {

                                    error =
                                        'This email already exists for an Admin'

                                } else if (staffEmailExists) {

                                    error =
                                        'This email already exists for a Staff'
                                }
                            }
                        }
                    }
                }
            }
        }

        // ============================================================
        // UPDATE ERROR
        // ============================================================

        setErrors((prev) => ({
            ...prev,
            [name]: error
        }))
    } 
          
    const validateForm = (data) => {
        const newErrors = {}

        if(!data.first_name.trim()){
            newErrors.first_name = 'First Name is required'
        }

        if(!data.last_name.trim()){
            newErrors.last_name = 'Last Name is required'
        }

        if(!data.age){
            newErrors.age = 'Age is required'
        }

        if(!data.dob.trim()){
            newErrors.dob = 'Date of Birth is required'
        }

        if (!data.aadhaar_no.trim()) {
            newErrors.aadhaar_no = 'Aadhaar number is required'
        } else if (!/^\d+$/.test(data.aadhaar_no)) {
            newErrors.aadhaar_no = 'Aadhaar should contain only digits.'
        } else if (data.aadhaar_no.length !== 12) {
            newErrors.aadhaar_no = 'Aadhaar should contain exactly 12 digits.'
        }

        if(!data.gender.trim()){
            newErrors.gender = 'Gender is required'
        }

        if(!data.address.trim()){
            newErrors.address = 'Address is required'
        }

        // Email
        if (data.email) {
            const email = data.email.trim()

            if (!email.includes('@')) {
                newErrors.email = 'Missing @ Symbol'
            } else {
                const [username, domain] = email.split('@')

                if (!username) {
                    newErrors.email = 'Username is missing before "@".'
                } else if (!domain) {
                    newErrors.email = 'Domain name is missing'
                } else if (!domain.includes('.')) {
                    newErrors.email = 'Missing "dot(.)" after domain name'
                } else {
                    const parts = domain.split('.')
                    const extension = parts.slice(1).join('.')

                    if (!extension) {
                        newErrors.email = 'Domain extension is missing'
                    } else {
                        const allowedDomains = [
                        'gmail.com',
                        'yahoo.com',
                        'hotmail.com',
                        'outlook.com'
                        ]

                        if (!allowedDomains.includes(domain.toLowerCase())) {
                            newErrors.email = 'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
                        }
                    }
                }
            }
        }

        // Phone
        if (data.phone) {
            if (!/^\d+$/.test(data.phone)) {
                newErrors.phone = 'Phone number contain only digits'
            } else if (!/^[6-9]\d{9}$/.test(data.phone)) {
                newErrors.phone = 'Phone number must start with 6, 7, 8 or 9 and contain exactly 10 digits'
            }
        }

        if(!data.role.trim()){
            newErrors.role = 'Role is required'
        }

        if(!data.department || String(data.department).trim() === '') { 
            newErrors.department = 'Department is required' 
        }
        
        return newErrors
    }

// =========================================================
// DOWNLOAD EXCEL TEMPLATE
// =========================================================

const handleExcel = () => {

    const excelData = [
        {
            first_name: '',
            last_name: '',
            dob: '',
            aadhaar_no: '',
            address: '',
            gender: '',
            email: '',
            phone: '',
            role: '',
            department: ''
        }
    ]

    const worksheet =
        XLSX.utils.json_to_sheet(excelData)

    const workbook =
        XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        'Staff'
    )

    XLSX.writeFile(
        workbook,
        'Staff_Template.xlsx'
    )

    toast.success(
        'Excel file downloaded successfully'
    )
}

// =========================================================
// HANDLE EXCEL FILE SELECTION
// =========================================================

const handleFileChange = (e) => {

    const file = e.target.files?.[0]

    if (!file) {
        return
    }

    const allowedExtensions = ['.xlsx', '.xls']

    const fileName = file.name.toLowerCase()

    const isValidFile = allowedExtensions.some(
        (extension) => fileName.endsWith(extension)
    )

    if (!isValidFile) {

        toast.error(
            'Please select an Excel file (.xlsx or .xls)'
        )

        e.target.value = ''

        setSelectedFile(null)

        return
    }

    setSelectedFile(file)
}

// =========================================================
// UPLOAD EXCEL
// =========================================================

const handleUpload = async (e) => {

    e.preventDefault()

    // =====================================================
    // CHECK SELECTED FILE
    // =====================================================

    if (!selectedFile) {

        toast.error(
            'Please select an Excel file'
        )

        return
    }

    try {

        setUploading(true)

        // =====================================================
        // FETCH DEPARTMENTS
        // =====================================================

        let departmentList = departments

        if (!departmentList.length) {

            const departmentResponse = await axios.get(
                `${config.baseurl}get_all_departments/`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }
            )

            departmentList = Array.isArray(
                departmentResponse.data
            )
                ? departmentResponse.data
                : departmentResponse.data?.data || []

            setDepartments(departmentList)
        }

        // =====================================================
        // CHECK DEPARTMENT DATA
        // =====================================================

        if (!departmentList.length) {

            toast.error(
                'No departments found'
            )

            return
        }

        // =====================================================
        // READ EXCEL FILE
        // =====================================================

        const fileData = await new Promise((resolve, reject) => {

            const reader = new FileReader()

            reader.onload = (event) => {

                resolve(event.target.result)
            }

            reader.onerror = () => {

                reject(
                    new Error('Failed to read Excel file')
                )
            }

            reader.readAsArrayBuffer(selectedFile)
        })

        // =====================================================
        // READ WORKBOOK
        // =====================================================

        const data = new Uint8Array(fileData)

        const workbook = XLSX.read(
            data,
            {
                type: 'array',
                cellDates: true
            }
        )

        if (!workbook.SheetNames.length) {

            toast.error(
                'Excel file does not contain any sheet'
            )

            return
        }

        const sheetName = workbook.SheetNames[0]

        const worksheet = workbook.Sheets[sheetName]

        // =====================================================
        // CONVERT EXCEL TO JSON
        // =====================================================

        const rows = XLSX.utils.sheet_to_json(
            worksheet,
            {
                defval: '',
                raw: true
            }
        )

        // =====================================================
        // EMPTY EXCEL
        // =====================================================

        if (!rows.length) {

            toast.error(
                'Excel file is empty'
            )

            return
        }

        // =====================================================
        // FETCH EXISTING DATA
        // =====================================================

        const [
            adminResponse,
            branchResponse,
            staffResponse
        ] = await Promise.all([

            axios.get(
                `${config.baseurl}get_all_admins/`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }
            ),

            axios.get(
                `${config.baseurl}get_all_branches/`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }
            ),

            axios.get(
                `${config.baseurl}get_all_staffs/`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }
            )
        ])

        // =====================================================
        // RESPONSE DATA
        // =====================================================

        const adminData = Array.isArray(
            adminResponse.data
        )
            ? adminResponse.data
            : adminResponse.data?.data || []

        const branchData = Array.isArray(
            branchResponse.data
        )
            ? branchResponse.data
            : branchResponse.data?.data || []

        const staffData = Array.isArray(
            staffResponse.data
        )
            ? staffResponse.data
            : staffResponse.data?.data || []

        // =====================================================
        // EXISTING ADMIN NAMES
        // =====================================================

        const existingAdminNames = new Set(

            adminData.map(
                (admin) =>
                    String(
                        admin.admin_name || ''
                    )
                        .trim()
                        .toLowerCase()
            )
        )

        // =====================================================
        // EXISTING BRANCH NAMES
        // =====================================================

        const existingBranchNames = new Set(

            branchData.map(
                (branch) =>
                    String(
                        branch.branch_name || ''
                    )
                        .trim()
                        .toLowerCase()
            )
        )

        // =====================================================
        // EXISTING STAFF NAMES
        // =====================================================

        const existingStaffNames = new Set(

            staffData.map(
                (staff) =>
                    `${String(
                        staff.first_name || ''
                    )
                        .trim()
                        .toLowerCase()} ${String(
                        staff.last_name || ''
                    )
                        .trim()
                        .toLowerCase()}`
                        .trim()
            )
        )

        // =====================================================
        // EXISTING EMAILS
        // =====================================================

        const existingEmails = new Set([

            ...adminData.map(
                (admin) =>
                    String(
                        admin.email || ''
                    )
                        .trim()
                        .toLowerCase()
            ),

            ...branchData.map(
                (branch) =>
                    String(
                        branch.email || ''
                    )
                        .trim()
                        .toLowerCase()
            ),

            ...staffData.map(
                (staff) =>
                    String(
                        staff.email || ''
                    )
                        .trim()
                        .toLowerCase()
            )
        ])

        // =====================================================
        // EXISTING PHONES
        // =====================================================

        const existingPhones = new Set([

            ...adminData.map(
                (admin) =>
                    String(
                        admin.phone || ''
                    ).trim()
            ),

            ...branchData.map(
                (branch) =>
                    String(
                        branch.phone || ''
                    ).trim()
            ),

            ...staffData.map(
                (staff) =>
                    String(
                        staff.phone || ''
                    ).trim()
            )
        ])

        // =====================================================
        // EXISTING AADHAAR
        // =====================================================

        const existingAadhaars = new Set(

            staffData.map(
                (staff) =>
                    String(
                        staff.aadhaar_no || ''
                    )
                        .replace(/\D/g, '')
                        .trim()
            )
        )

        // =====================================================
        // ARRAYS
        // =====================================================

        const newStaffs = []

        const uploadErrors = []

        // =====================================================
        // PROCESS EACH EXCEL ROW
        // =====================================================

        for (
            let index = 0;
            index < rows.length;
            index++
        ) {

            const row = rows[index]

            // Excel header is row 1
            // First data row is row 2
            const rowNumber = index + 2

            // =================================================
            // BASIC VALUES
            // =================================================

            const firstName = String(
                row.first_name || ''
            ).trim()

            const lastName = String(
                row.last_name || ''
            ).trim()

            const email = String(
                row.email || ''
            )
                .trim()
                .toLowerCase()

            const phone = String(
                row.phone || ''
            )
                .trim()
                .replace(/\s/g, '')

            const aadhaar = String(
                row.aadhaar_no || ''
            )
                .trim()
                .replace(/\s/g, '')

            const address = String(
                row.address || ''
            ).trim()

            const gender = String(
                row.gender || ''
            ).trim()

            const role = String(
                row.role || ''
            ).trim()

            // =================================================
            // DOB
            // =================================================

            let dobValue = ''

            if (row.dob instanceof Date) {

                const year =
                    row.dob.getFullYear()

                const month =
                    String(
                        row.dob.getMonth() + 1
                    ).padStart(2, '0')

                const day =
                    String(
                        row.dob.getDate()
                    ).padStart(2, '0')

                dobValue =
                    `${year}-${month}-${day}`

            } else {

                const dobString = String(
                    row.dob || ''
                ).trim()

                if (
                    /^\d{2}\/\d{2}\/\d{4}$/.test(
                        dobString
                    )
                ) {

                    const [
                        day,
                        month,
                        year
                    ] = dobString.split('/')

                    dobValue =
                        `${year}-${month}-${day}`

                } else {

                    dobValue = dobString
                }
            }

            // =================================================
            // CALCULATE AGE
            // =================================================

            let age = ''

            if (dobValue) {

                const birthDate =
                    new Date(`${dobValue}T00:00:00`)

                if (
                    !Number.isNaN(
                        birthDate.getTime()
                    )
                ) {

                    const today = new Date()

                    age =
                        today.getFullYear() -
                        birthDate.getFullYear()

                    const monthDifference =
                        today.getMonth() -
                        birthDate.getMonth()

                    if (
                        monthDifference < 0 ||
                        (
                            monthDifference === 0 &&
                            today.getDate() <
                            birthDate.getDate()
                        )
                    ) {

                        age--
                    }

                    // Future DOB
                    if (age < 0) {

                        age = ''
                    }
                }
            }

            // =================================================
            // DEPARTMENT
            // =================================================

            const departmentValue = String(
                row.department ?? ''
            ).trim()

            let departmentId = ''

            if (!departmentValue) {

                uploadErrors.push({
                    row: rowNumber,
                    errors: [
                        'Department is required'
                    ]
                })

                continue
            }

            // =================================================
            // DEPARTMENT ID
            // =================================================

            if (
                /^\d+$/.test(
                    departmentValue
                )
            ) {

                // Excel contains department ID

                const id =
                    Number(
                        departmentValue
                    )

                const departmentExists =
                    departmentList.some(
                        (dept) =>
                            Number(
                                dept.id
                            ) === id
                    )

                if (!departmentExists) {

                    uploadErrors.push({
                        row: rowNumber,
                        errors: [
                            `Department ID "${departmentValue}" does not exist`
                        ]
                    })

                    continue
                }

                departmentId = id

            } else {

                // Excel contains department name

                const matchedDepartment =
                    departmentList.find(
                        (dept) =>
                            String(
                                dept.department_name || ''
                            )
                                .trim()
                                .toLowerCase() ===
                            departmentValue
                                .toLowerCase()
                    )

                if (!matchedDepartment) {

                    uploadErrors.push({
                        row: rowNumber,
                        errors: [
                            `Department "${departmentValue}" does not exist`
                        ]
                    })

                    continue
                }

                departmentId =
                    Number(
                        matchedDepartment.id
                    )
            }

            // =================================================
            // STAFF DATA
            // =================================================

            const staffPayload = {

                first_name:
                    firstName,

                last_name:
                    lastName,

                dob:
                    dobValue,

                // Age calculated from DOB
                age:
                    age,

                aadhaar_no:
                    aadhaar,

                address:
                    address,

                gender:
                    gender,

                email:
                    email,

                phone:
                    phone,

                role:
                    role,

                // Backend gets department ID
                department:
                    departmentId
            }

            // =================================================
            // VALIDATION
            // =================================================

            const rowErrors =
                validateForm(
                    staffPayload
                )

            if (
                Object.keys(
                    rowErrors
                ).length > 0
            ) {

                uploadErrors.push({
                    row: rowNumber,
                    errors:
                        Object.values(
                            rowErrors
                        )
                })

                continue
            }

            // =================================================
            // FULL NAME
            // =================================================

            const fullName =
                `${firstName} ${lastName}`
                    .trim()
                    .toLowerCase()

            // =================================================
            // DUPLICATE NAME - ADMIN
            // =================================================

            if (
                existingAdminNames.has(
                    fullName
                )
            ) {

                uploadErrors.push({
                    row: rowNumber,
                    errors: [
                        'Staff name already exists as Admin'
                    ]
                })

                continue
            }

            // =================================================
            // DUPLICATE NAME - BRANCH
            // =================================================

            if (
                existingBranchNames.has(
                    fullName
                )
            ) {

                uploadErrors.push({
                    row: rowNumber,
                    errors: [
                        'Staff name already exists as Branch'
                    ]
                })

                continue
            }

            // =================================================
            // DUPLICATE NAME - STAFF
            // =================================================

            if (
                existingStaffNames.has(
                    fullName
                )
            ) {

                uploadErrors.push({
                    row: rowNumber,
                    errors: [
                        'Staff name already exists'
                    ]
                })

                continue
            }

            // =================================================
            // DUPLICATE EMAIL
            // =================================================

            if (
                email &&
                existingEmails.has(
                    email
                )
            ) {

                uploadErrors.push({
                    row: rowNumber,
                    errors: [
                        'Email already exists'
                    ]
                })

                continue
            }

            // =================================================
            // DUPLICATE PHONE
            // =================================================

            if (
                phone &&
                existingPhones.has(
                    phone
                )
            ) {

                uploadErrors.push({
                    row: rowNumber,
                    errors: [
                        'Phone number already exists'
                    ]
                })

                continue
            }

            // =================================================
            // DUPLICATE AADHAAR
            // =================================================

            if (
                aadhaar &&
                existingAadhaars.has(
                    aadhaar
                )
            ) {

                uploadErrors.push({
                    row: rowNumber,
                    errors: [
                        'Aadhaar number already exists'
                    ]
                })

                continue
            }

            // =================================================
            // ADD TO NEW STAFF
            // =================================================

            newStaffs.push(
                staffPayload
            )

            // =================================================
            // UPDATE SETS
            // Prevent duplicate rows in same Excel
            // =================================================

            existingStaffNames.add(
                fullName
            )

            if (email) {

                existingEmails.add(
                    email
                )
            }

            if (phone) {

                existingPhones.add(
                    phone
                )
            }

            if (aadhaar) {

                existingAadhaars.add(
                    aadhaar
                )
            }
        }

        // =====================================================
        // SHOW VALIDATION ERRORS
        // =====================================================

        if (
            uploadErrors.length > 0
        ) {

            console.log(
                'Excel Upload Errors:',
                uploadErrors
            )

            uploadErrors.forEach(
                (item) => {

                    item.errors.forEach(
                        (errorMessage) => {

                            toast.error(
                                `Row ${item.row}: ${errorMessage}`
                            )
                        }
                    )
                }
            )
        }

        // =====================================================
        // NO VALID STAFF
        // =====================================================

        if (!newStaffs.length) {

            toast.error(
                'No valid staff records found in the Excel file'
            )

            return
        }

        // =====================================================
        // CREATE STAFF
        // =====================================================

        let successCount = 0

        for (
            const staff of newStaffs
        ) {

            try {

                console.log(
                    'Creating staff:',
                    staff
                )

                const response =
                    await axios.post(
                        `${config.baseurl}create_staff/`,
                        staff,
                        {
                            headers: {
                                'Content-Type':
                                    'application/json',

                                'Authorization':
                                    `Token ${token}`
                            }
                        }
                    )

                console.log(
                    'Create staff response:',
                    response.data
                )

                if (
                    response.status === 200 ||
                    response.status === 201
                ) {

                    successCount++

                }

            } catch (error) {

                console.error(
                    'Staff creation error:',
                    error.response?.data || error
                )

                const errorData =
                    error.response?.data

                if (
                    errorData?.message &&
                    typeof errorData.message === 'object'
                ) {

                    Object.entries(
                        errorData.message
                    ).forEach(
                        ([field, messages]) => {

                            if (
                                Array.isArray(
                                    messages
                                )
                            ) {

                                messages.forEach(
                                    (message) => {

                                        toast.error(
                                            `Row staff ${staff.first_name}: ${message}`
                                        )
                                    }
                                )

                            } else {

                                toast.error(
                                    `Row staff ${staff.first_name}: ${messages}`
                                )
                            }
                        }
                    )

                } else {

                    const message =
                        errorData?.message ||
                        errorData?.error ||
                        errorData?.detail ||
                        'Failed to create staff'

                    toast.error(
                        `Staff ${staff.first_name}: ${message}`
                    )
                }
            }
        }

        // =====================================================
        // FINAL RESULT
        // =====================================================

        if (
            successCount > 0
        ) {

            toast.success(
                `${successCount} staff member${
                    successCount > 1
                        ? 's'
                        : ''
                } uploaded successfully`
            )

            // Clear selected file
            setSelectedFile(null)

            // Close upload modal
            setOpenUploadModal(false)

            // Refresh page after a short delay
            setTimeout(() => {

                window.location.reload()

            }, 800)

        } else {

            toast.error(
                'No staff member was added'
            )
        }

    } catch (error) {

        console.error(
            'Excel upload error:',
            error.response?.data || error
        )

        const errorData =
            error.response?.data

        const message =
            errorData?.message ||
            errorData?.error ||
            errorData?.detail ||
            'Failed to upload Excel file'

        toast.error(
            typeof message === 'string'
                ? message
                : 'Failed to upload Excel file'
        )

    } finally {

        setUploading(false)
    }
}

const handleSubmit = async(e) => {
        e.preventDefault()

        const validationErrors = validateForm(formData)
        setErrors(validationErrors)

        if(Object.keys(validationErrors).length > 0){
            return
        }


        try{
            setLoading(true)

            const [existingStaffsResponse, existingAdminsResponse, existingBranchesResponse] = await Promise.all([
                axios.get(`${config.baseurl}get_all_staffs/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }),

                axios.get(`${config.baseurl}get_all_admins/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }),

                axios.get(`${config.baseurl}get_all_branches/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                })
            ])

            const existingStaffs = existingStaffsResponse.data?.data || []
            const existingAdmins = existingAdminsResponse.data?.data || []
            const existingBranches = existingBranchesResponse.data?.data || []

            const staffFirstName = formData.first_name.trim().toLowerCase()
            const staffLastName = formData.last_name.trim().toLowerCase()

            const staffFullName = `${staffFirstName} ${staffLastName}`.trim()

            const staffNameExists = existingStaffs.some((staff) => {

                const existingFirstName = String(
                    staff.first_name || ''
                ).trim().toLowerCase()

                const existingLastName = String(
                    staff.last_name || ''
                ).trim().toLowerCase()

                const existingFullName =
                    `${existingFirstName} ${existingLastName}`.trim()

                return existingFullName === staffFullName
            })

            if (staffNameExists) {
                toast.error('Staff name already exists')
                return
            }

            const adminNameExists = existingAdmins.some((admin) => {

                const existingAdminName = String(
                    admin.admin_name || ''
                ).trim().toLowerCase()

                return existingAdminName === staffFullName
            })

            if (adminNameExists) {
                toast.error('This name already exists as an Admin')
                return
            }

            const branchNameExists = existingBranches.some((branch) => {

                const existingBranchName = String(
                    branch.branch_name || ''
                ).trim().toLowerCase()

                return existingBranchName === staffFullName
            })

            if (branchNameExists) {
                toast.error('This name already exists as a Branch')
                return
            }    

            const payload = {
                first_name:formData.first_name,
                last_name:formData.last_name,
                age:formData.age,
                dob:formData.dob,
                aadhaar_no:formData.aadhaar_no,
                address:formData.address,
                gender:formData.gender,
                email:formData.email,
                phone:formData.phone,
                role:formData.role,
                department:formData.department
            }

            const res = await axios.post(`${config.baseurl}create_staff/`, payload, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })

            if(res.status === 200 || res.status === 201){
                toast.success(res.data?.message || 'Staff created successfully')
                setFormData({
                    first_name:'',
                    last_name:'',
                    age:'',
                    dob:'',
                    aadhaar_no:'',
                    address:'',
                    gender:'',
                    email:'',
                    phone:'',
                    role:'',
                    department:''
                })
                setTimeout(() => {
                    navigate(-1)
                }, 300)
            }else{
                toast.error(res.data?.message || 'Failed to create staff')
            }
        } catch (error) {
            console.error('Error:', error.response?.data || error)

            const errorData = error.response?.data

            if (errorData?.message && typeof errorData.message === 'object') {

                Object.entries(errorData.message).forEach(([field, messages]) => {

                    if (Array.isArray(messages)) {
                        messages.forEach((msg) => {
                            toast.error(msg)
                        })
                    } else {
                        toast.error(messages)
                    }

                })

            } else if (errorData?.message) {

                toast.error(errorData.message)

            } else if (errorData?.error) {

                toast.error(errorData.error)

            } else if (errorData?.detail) {

                toast.error(errorData.detail)

            } else {

                toast.error('Failed to create staff')
            }

        } finally {
            setLoading(false)
        }
    }

    const closeUploadModal = () => {
        if(uploading){
            return
        }

        setSelectedFile(null)
        setOpenUploadModal(false)
    }

    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0">
        <AdminHeader/>

        {/* HEADER */}
        <div className="max-w-7xl mx-auto px-6 pt-16 pb-6">
            <div className="items-center justify-between text-center">
                <h1 className="mt-1 text-3xl font-bold text-slate-800">
                    ADD Staffs
                </h1>

                <p className="mt-2 text-sm text-slate-500">
                    Create a new staff or add multiple staffs using an Excel file.
                </p>
            </div>
        </div>

        {/* FORM SECTION */}
        <div className="max-w-7xl mx-auto px-6 pb-12">
            <div className='mx-auto max-w-5xl mb-4 flex justify-end items-center gap-3'>
            
                {/* Excel Actions */}
                <button
                    type="button"
                    onClick={handleExcel}
                    className="inline-flex items-center justify-center rounded-xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700"
                >
                    Download Excel File
                </button>

                <button
                    type="button"
                    onClick={() =>setOpenUploadModal(true)}
                    className="inline-flex items-center justify-center rounded-xl bg-[#000435] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326]"
                >
                    Upload Excel File
                </button>
            </div>
            
            <div className="mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">

                {/* Form Header */}
                <div className="border-b border-slate-200 bg-slate-50 px-6 py-5 text-center text-lg">
                    <h2 className="text-lg font-bold text-slate-800">
                        Staff Registration Form
                    </h2>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="p-6 md:p-8">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                        {/* First Name */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="first_name"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                First Name
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="first_name"
                                type="text"
                                name="first_name"
                                placeholder="Enter first name"
                                value={formData.first_name}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.first_name
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.first_name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.first_name}</p>
                            )}
                        </div>

                        {/* Last Name */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="last_name"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Last Name
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="last_name"
                                type="text"
                                name="last_name"
                                placeholder="Enter last name"
                                value={formData.last_name}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.last_name
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.last_name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.last_name}</p>
                            )}
                        </div>

                        {/* Date of Birth */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="dob"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Date of Birth
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="dob"
                                type="date"
                                name="dob"
                                placeholder="Enter Date of Birth"
                                value={formData.dob}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.dob
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.dob && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.dob}</p>
                            )}
                        </div>

                        {/* Age */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="age"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Age
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="age"
                                type="number"
                                name="age"
                                placeholder="Enter Age"
                                value={formData.age}
                                readOnly
                                className={`${inputClass} ${errors.age
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.age && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.age}</p>
                            )}
                        </div>

                        {/* Aadhaar Number */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="aadhaar_no"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Aadhaar Number
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="aadhaar_no"
                                type="text"
                                name="aadhaar_no"
                                placeholder="Enter Aadhaar Number"
                                value={formData.aadhaar_no}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.aadhaar_no
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.aadhaar_no && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.aadhaar_no}</p>
                            )}
                        </div>

                        {/* Address */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="address"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Address
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <textarea
                                id="address"
                                name="address"
                                rows={4}
                                placeholder="Enter complete branch address"
                                value={formData.address}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.address
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.address && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.address}</p>
                            )}
                        </div>

                        {/* Gender */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="gender"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Gender
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <select
                                id="gender"
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.gender
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>

                            {errors.gender && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.gender}</p>
                            )}
                        </div>

                        {/* Phone */}
                        <div>
                            <label
                                htmlFor="phone"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Phone Number
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="phone"
                                type="phone"
                                name="phone"
                                placeholder="Enter 10-digit phone number"
                                value={formData.phone}
                                onChange={handleChange}
                                maxLength={10}
                                inputMode="numeric"
                                className={`${inputClass} ${errors.phone
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.phone && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.phone}</p>
                            )}
                        </div>

                        {/* Email */}
                        <div>
                            <label
                                htmlFor="email"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Email Address
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="email"
                                type="email"
                                name="email"
                                placeholder="Enter email address"
                                value={formData.email}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.email
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.email && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.email}</p>
                            )}
                        </div>

                        {/* Role */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="role"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Role
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <select
                                id="role"
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.role
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            >
                                <option value="">Select Role</option>
                                <option value="Manager">Manager</option>
                                <option value="Accountant">Accountant</option>
                                <option value="Telecaller">Telecaller</option>
                            </select>

                            {errors.role && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.role}</p>
                            )}
                        </div>

                        {/* Departments */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="department"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Department
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <select
                                id="department"
                                name="department"
                                value={formData.department}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.department
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            >
                                <option value="">Select Department</option>
                                {departments.map((dept) => (
                                    <option
                                        key={dept.id}
                                        value={dept.id}
                                    >
                                        {dept.department_name}
                                    </option>
                                ))}
                            </select>

                            {errors.department && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.department}</p>
                            )}
                        </div>
                    </div>

                    {/* Form Actions */}
                    <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            disabled={loading}
                            className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading || Object.keys(errors).some(key => errors[key])}
                            className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {loading ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>
                </form>
            </div>
        </div>

        {/* EXCEL UPLOAD MODAL */}
        {openUploadModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 px-4 backdrop-blur-sm">
                <div className="w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl">
                
                    {/* Modal Header */}
                    <div className="flex items-center justify-between bg-[#000435] px-6 py-5">
                        <div>
                            <h2 className="text-xl font-bold text-white">Upload Staffs</h2>

                            <p className="mt-1 text-sm text-slate-300">
                            Import new staffs using an Excel file.
                            </p>
                        </div>

                        <button
                            type="button"
                            onClick={closeUploadModal}
                            disabled={uploading}
                            aria-label="Close"
                            className="flex h-9 w-9 items-center justify-center rounded-lg text-2xl text-red-500 hover:text-red-600 transition disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            &times;
                        </button>
                    </div>

                    {/* Modal Body */}
                    <form onSubmit={handleUpload} className="p-6">

                        {/* File Selection */}
                        <div className="rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 p-8 text-center transition hover:border-blue-300">
                            <div className="mb-5">
                                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100">
                                    <span className="text-2xl">📊</span>
                                </div>

                                <p className="text-lg font-bold text-slate-800">
                                    Select Excel File
                                </p>

                                <p className="mt-1 text-sm text-slate-500">
                                    Supported formats: .xlsx and .xls
                                </p>
                            </div>

                            <input
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={handleFileChange}
                                disabled={uploading}
                                className="block w-full text-sm text-slate-600 file:mr-4 file:rounded-lg file:border-0 file:bg-white file:border-r file:border-r-slate-300 file:px-4 file:py-2 file:font-semibold file:text-slate-700 file:shadow-sm hover:file:bg-blue-50 border border-slate-300 rounded-lg bg-slate-300"
                            />

                            {selectedFile && (
                                <div className="mt-4 rounded-xl border border-blue-200 bg-blue-50 p-4 text-left">
                                    <p className="text-xs font-semibold uppercase tracking-wide text-blue-700">
                                        Selected File
                                    </p>

                                    <p className="mt-1 break-all text-sm font-medium text-blue-900">
                                        {selectedFile.name}
                                    </p>
                                </div>
                            )}
                        </div>

                        {/* Modal Actions */}
                        <div className="mt-6 flex justify-end gap-3">
                            <button
                                type="button"
                                onClick={closeUploadModal}
                                disabled={uploading}
                                className="rounded-xl bg-slate-100 px-5 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                disabled={ uploading || !selectedFile }
                                className="rounded-xl bg-[#000435] px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                {uploading ? 'Uploading...' : 'Upload'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        )}
    </div>
  )
}
